export const API_URL = `${process.env.REACT_APP_BASE_URL}`
export const TOKEN_URL: string = `${process.env.REACT_APP_BASE_URL}/oauth/token`
export const ACCESS_TOKEN_KEY = 'ACCESS_TOKEN'
export const SKIP_AUTH_GUARD = false
import { Grid } from 'antd'
import _ from 'lodash'

export const useWidth = (): string => {
	const screens = Grid.useBreakpoint()
	const width = _.last(_.keys(_.pickBy(screens))) || 'xs'
	return width
}

export const Colors = {
	White: '#FFF',
	Black: '#000',
	Background: '#BDC5CF',
	Red: '#D22229',
	Primary: '#254a89',
	Green: '#18B23C',
	Text: '#1C1B1A',
	Grey: {
		100: '#EFEFEF',
		200: '#FCFCFC',
		300: '#E4E4E4',
		400: '#E3E3E3',
		500: '#7B808c',
	},
	Blue: {
		Dark: '#254a89',
		Light: '#3F8EFC',
		Opacity: '#ECF4FF',
	},
}

export const DATE_FORMATS = {
	DISPLAY: 'MM/DD/YYYY',
	DISPLAY_TIME: 'MM/DD/YYYY, h:mm:ss a',
	API: 'YYYY-MM-DD',
}

